import React, { useState } from 'react';
import './HowToReport.css';

const actions = [
  {
    step: '1',
    urgency: 'URGENT',
    title: 'Opposez-vous immédiatement à votre banque',
    icon: '🏦',
    color: 'var(--red-bright)',
    actions: [
      'Appelez le 0800 de votre banque (numéro au dos de votre carte)',
      'Demandez l\'opposition sur les prélèvements de JumpVendor',
      'Demandez le remboursement par rétrofacturation (chargeback)',
      'Faites bloquer votre carte si nécessaire',
      'Demandez une nouvelle carte avec un nouveau numéro',
    ],
    note: 'Délai : vous avez 13 mois pour contester un prélèvement non autorisé (directive DSP2).'
  },
  {
    step: '2',
    urgency: 'IMPORTANT',
    title: 'Signalez à la DGCCRF',
    icon: '⚖️',
    color: 'var(--orange)',
    actions: [
      'Appelez le 0809 540 550 (service SignalConso)',
      'Ou signalez en ligne sur signal.conso.gouv.fr',
      'Décrivez précisément les prélèvements et le site',
      'Joignez vos relevés bancaires comme preuve',
    ],
    note: 'Plus il y a de signalements, plus vite les autorités agissent contre le site.'
  },
  {
    step: '3',
    urgency: 'RECOMMANDÉ',
    title: 'Déposez une plainte à la police',
    icon: '🚔',
    color: 'var(--yellow)',
    actions: [
      'Rendez-vous à votre commissariat ou gendarmerie',
      'Portez plainte pour escroquerie (Art. 313-1 CP)',
      'Apportez : relevés bancaires, emails de confirmation, captures d\'écran',
      'Ou déposez plainte en ligne sur service-public.fr',
    ],
    note: 'Conservez le numéro de plainte pour votre banque et l\'assurance.'
  },
  {
    step: '4',
    urgency: 'UTILE',
    title: 'Signalez à Pharos (Internet)',
    icon: '🌐',
    color: '#888',
    actions: [
      'Rendez-vous sur internet-signalement.gouv.fr',
      'Signalez le site comme contenu frauduleux',
      'Cette plateforme transmet à l\'OCLCTIC (cybercriminalité)',
    ],
    note: 'Signalement rapide, moins de 5 minutes.'
  },
];

export default function HowToReport() {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(
      'Objet : Signalement arnaque JumpVendor.com\n\nBonjour,\nJe souhaite signaler le site jumpvendor.com pour escroquerie. Ce site m\'a prélevé plusieurs montants non autorisés suite à une redirection frauduleuse depuis TikTok. Prélèvements observés : [montants]. Date : [date]. Je joins mes relevés bancaires en preuve.\nCordialement'
    ).then(() => { setCopied(true); setTimeout(() => setCopied(false), 3000); });
  };

  return (
    <section className="report section" id="signaler" aria-labelledby="report-title">
      <div className="container">
        <span className="tag">Guide d'action</span>
        <h2 id="report-title" className="section-title" style={{ color: 'white' }}>
          Comment Agir — <span style={{ color: 'var(--red-bright)' }}>Étape par Étape</span>
        </h2>
        <p className="section-subtitle">
          Suivez ces étapes dans l'ordre. Agir rapidement maximise vos chances de remboursement.
        </p>

        <div className="report__grid">
          {actions.map((a, i) => (
            <div key={i} className="report__card" style={{ '--card-color': a.color }}>
              <div className="report__card-header">
                <span className="report__card-step">{a.step}</span>
                <span className="report__card-urgency" style={{ background: a.color, color: a.color === 'var(--yellow)' ? '#000' : '#fff' }}>
                  {a.urgency}
                </span>
                <span className="report__card-icon">{a.icon}</span>
              </div>
              <h3 className="report__card-title">{a.title}</h3>
              <ul className="report__card-list">
                {a.actions.map((action, j) => (
                  <li key={j}>{action}</li>
                ))}
              </ul>
              <div className="report__card-note">💡 {a.note}</div>
            </div>
          ))}
        </div>

        <div className="report__template">
          <h3>📋 Modèle de message pour votre banque</h3>
          <div className="report__template-box">
            <p><strong>Objet :</strong> Demande de rétrofacturation — Prélèvements non autorisés JumpVendor.com</p>
            <p><br />Bonjour,<br /><br />
            Suite à une commande sur une publicité TikTok, j'ai été redirigé(e) frauduleusement vers le site jumpvendor.com qui a effectué <strong>[X] prélèvements non autorisés</strong> sur mon compte les [dates] pour les montants de [montants].
            <br /><br />
            Je n'ai jamais donné mon accord explicite pour ces prélèvements et aucun produit/service n'a été fourni. Conformément à la directive DSP2, je demande la rétrofacturation immédiate de ces montants.
            <br /><br />
            Pièces jointes : relevé bancaire, confirmation de commande, captures d'écran.<br /><br />
            Cordialement</p>
          </div>
          <button className="report__copy-btn" onClick={copyEmail}>
            {copied ? '✓ Copié !' : '📋 Copier ce modèle'}
          </button>
        </div>
      </div>
    </section>
  );
}
